import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OtpState {
  otp: string | null;
  userId: string;
}

const initialState: OtpState = {
  otp: null,
  userId: "",
};

const otpSlice = createSlice({
  name: "otpSlice",
  initialState,
  reducers: {
    setOtp: (state, action: PayloadAction<string>) => {
      state.otp = action.payload;
    },
    clearOtp: (state) => {
      state.otp = null;
    },
    setUser: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
  },
});

export const { setOtp, clearOtp, setUser } = otpSlice.actions;
export default otpSlice;
